import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http, RequestOptions, XHRBackend } from '@angular/http';
import {HttpClientModule,HttpClient} from '@angular/common/http';
import { MyDatePickerModule } from 'mydatepicker';
import { EqualValidator } from './equal-validator.directive';
import { AppComponent } from './app.component';
import { HttpTestService } from './services/http.service';
import { sessionServices } from './services/session.services';
import { CanActivateViaAuthGuard } from './guard/activateGuard';
import { BaseProxyService } from './proxy/base-proxy.service';
import { paymentResponseComponent } from '../app/components/success/paymentResponse.component';
import { requestMangementComponent } from '../app/components/request/requestMangement.component';
// import { routes } from './config/routes/app.routes';
import { AppRoutingModule, routingComponents } from './config/routes/app.routes';
import { TruncateModule } from 'ng2-truncate';
import { ChartsModule } from 'ng2-charts';
import { NgxBarcodeModule } from 'ngx-barcode';
import { PaymentDetailsComponent } from './components/payment-details/payment-details.component';
import { DatePipe } from '@angular/common';
import { ExcelService } from './services/excel.service';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ChatbotComponent, SafeHtmlPipe } from './components/chatbot/chatbot.component';
import { SolarPvComponent } from './components/solar-pv/solar-pv.component';
import { BusySpinnerComponent } from './services/busy-spinner/busy-spinner.component';
import { PrepaidBalanceComponent } from './components/prepaid-balance/prepaid-balance.component';
import { PrepaidPaymentSuccessComponent } from './components/prepaid-payment-success/prepaid-payment-success.component';
import { PrepaidPaymentFailComponent } from './components/prepaid-payment-fail/prepaid-payment-fail.component';
import { PrepaidSuccessMobileComponent } from './components/prepaid-success-mobile/prepaid-success-mobile.component';
import { ViewPrepaidTransactionComponent } from './components/view-prepaid-transaction/view-prepaid-transaction.component';
import { PrepaidConsumptionComponent } from './components/prepaid-consumption/prepaid-consumption.component';
import { CommonService } from './services/common/common.service';
import { SecurityService } from './services/security/security.service';
// import { CustomValidationService } from './services/custom-validation/custom-validation.service';



@NgModule({
  declarations: [
    AppComponent,
    EqualValidator,
    routingComponents,
    paymentResponseComponent,
    requestMangementComponent,
    PaymentDetailsComponent,
    FeedbackComponent,
    ChatbotComponent,
    ChangePasswordComponent,
    SafeHtmlPipe,
    SolarPvComponent,
    BusySpinnerComponent,
    PrepaidBalanceComponent,
    PrepaidPaymentSuccessComponent,
    PrepaidPaymentFailComponent,
    PrepaidSuccessMobileComponent,
    ViewPrepaidTransactionComponent,
    PrepaidConsumptionComponent
   ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    MyDatePickerModule, 
    ReactiveFormsModule,
	  TruncateModule,
	  ChartsModule,
    NgxBarcodeModule
	],
  providers: [BaseProxyService, HttpTestService, sessionServices, CommonService, HttpClientModule,HttpClient, CanActivateViaAuthGuard, DatePipe, ExcelService, SecurityService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/app.module.ts